import React from "react";
import ArgoCD from "../assets/argo.png";
import Artifactory from "../assets/artifactory.png";
import AWS from "../assets/aws.png";
import Coralogix from "../assets/coralogix.png";
import Datadog from "../assets/datadog.png";
import Docker from "../assets/docker-240.png";
import Git from "../assets/git.png";
import Golang from "../assets/golang.png";
import Grafana from "../assets/grafana.png";
import Jenkins from "../assets/jenkins.png";
import Kibana from "../assets/kibana.png";
import Mongo from "../assets/mongo.png";
import MySQL from "../assets/mysql.png";
import SQLite from "../assets/sqlite.png";
import Prometheus from "../assets/prometheus.png";
import Python from "../assets/python.png";
import Terraform from "../assets/terraform.png";
import ReactImg from "../assets/react.png";
import K8S from "../assets/k8s.png";
import Linkerd from "../assets/linkerd.png";
import Vault from "../assets/vault.png";
import ArgoRollouts from "../assets/argo_rollouts.png";
import WilWiz from "../assets/wiz.png";
import Chainguard from "../assets/chainguard.png";
import Redis from "../assets/redis.png";
import Karpenter from "../assets/karpenter.png";
import Keda from "../assets/keda.png";
import GCP from "../assets/gcp.png";
import GHA from "../assets/gha.png";

const Skills = () => {
  return (
    <div name="tech-stack" className="w-full min-h-screen bg-[#0a192f] text-gray-300 scroll-mt-20">
      {/* Container */}
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div>
          <p className="text-4xl font-bold inline border-b-4 border-violet-600 ">
            Tech Stack
          </p>
          <p className="py-4 font-bold text-base">
            Technologies and tools I've worked with.
          </p>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-4">
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={K8S} alt="K8s icon" />
            <p className="font-medium text-xs">K8s</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={AWS} alt="AWS icon" />
            <p className="font-medium text-xs">AWS</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={GCP} alt="GCP icon" />
            <p className="font-medium text-xs">GCP</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Terraform} alt="Terraform icon" />
            <p className="font-medium text-xs">Terraform</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Prometheus} alt="Prometheus icon" />
            <p className="font-medium text-xs">Prometheus</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Grafana} alt="Grafana icon" />
            <p className="font-medium text-xs">Grafana</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Python} alt="Python icon" />
            <p className="font-medium text-xs">Python</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Golang} alt="Golang icon" />
            <p className="font-medium text-xs">Golang</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Jenkins} alt="Jenkins icon" />
            <p className="font-medium text-xs">Jenkins</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={ArgoCD} alt="ArgoCD icon" />
            <p className="font-medium text-xs">ArgoCD</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Coralogix} alt="Coralogix icon" />
            <p className="font-medium text-xs">Coralogix</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Datadog} alt="Datadog icon" />
            <p className="font-medium text-xs">Datadog</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Linkerd} alt="Linkerd icon" />
            <p className="font-medium text-xs">Linkerd</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Mongo} alt="Mongo icon" />
            <p className="font-medium text-xs">Mongo</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={ArgoRollouts} alt="Argo Rollouts icon" />
            <p className="font-medium text-xs">Argo Rollouts</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Docker} alt="Docker icon" />
            <p className="font-medium text-xs">Docker</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={WilWiz} alt="Wiz icon" />
            <p className="font-medium text-xs">Wiz</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Chainguard} alt="Chainguard icon" />
            <p className="font-medium text-xs">Chainguard</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={MySQL} alt="MySQL icon" />
            <p className="font-medium text-xs">MySQL</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={SQLite} alt="SQLite icon" />
            <p className="font-medium text-xs">SQLite</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Redis} alt="Redis icon" />
            <p className="font-medium text-xs">Redis</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Karpenter} alt="Karpenter icon" />
            <p className="font-medium text-xs">Karpenter</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Keda} alt="Keda icon" />
            <p className="font-medium text-xs">Keda</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={GHA} alt="GHA icon" />
            <p className="font-medium text-xs">GHA</p>
          </div>
          <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500 flex flex-col items-center justify-center text-center p-4">
            <img className="w-16 h-16 object-contain mb-2" src={Artifactory} alt="Artifactory icon" />
            <p className="font-medium text-xs">Artifactory</p>
          </div>
          <p className="pt-6 text-sm text-[#8892b0] italic">
            … and many more tools, platforms and technologies across the full DevOps stack.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Skills;